Handlebars.registerPartial('amenity', '\
  {{#if id}}\
    {{#if selected}}  \
      <table class="select2-table selected">\
    {{else}}\
      <table class="select2-table">\
    {{/if}}\
      <thead>\
        <tr>\
          <th>{{I18n "name"}}</th>\
          <th>{{I18n "value"}}</th>\
        </tr>\
      </thead>\
      <tbody>\
        <tr>\
          <td>{{name}}</td>\
          <td>{{value}}</td>\
        </tr>\
      </tbody>\
    </table>\
  {{/if}}\
');

var amenity_template = Handlebars.compile('{{> amenity}}');

window.amenity_template_result = function (obj) {
  if (obj.disabled) {
    return obj.text;
  } else {
    return amenity_template(JSON.parse(obj.text));
  }
};

window.amenity_template_selection = function (obj) {
  if (!obj.selected) {
    return obj.text;
  } else {
    var json = JSON.parse(obj.text)
    json.selected = true;
    return amenity_template(json);
  }
};